import Axios from 'axios';


var headers = {
    'Content-Type': 'application/json',


}
export default {


    getAll() {
        //console.log(BASE_URL)
        const BASE_URL = '/public/api';
        return Axios.get(BASE_URL + '/debtors', { headers: headers })
    },

    create(data) {
        const BASE_URL = '/public/api';
        return Axios.post(BASE_URL + '/debtors', data, { headers: headers });

    },

    update(id, data) {
        const BASE_URL = '/public/api';
        return Axios.put(BASE_URL + '/debtors/' + id, data, { headers: headers });
    },

    delete(id) {
        const BASE_URL = '/public/api';
        return Axios.delete(BASE_URL + '/debtors/' + id, { headers: headers });
    },

}